<template>
    <div class="grid grid-cols-6 gap-6">
      <div class="col-span-6 sm:col-span-3 lg:col-span-2">
        <label for="nombre_tipo_identificacion" class="block text-sm font-medium text-gray-700">Nombre Tipo Documento</label>
        <input type="text" id="nombre_tipo_identificacion" :value="loadData.nombre_tipo_identificacion"
               @change="(newTipoDoducumento)=>$emit('updateValues', {'nombre_tipo_identificacion': newTipoDoducumento.target.value})"
               class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TipoDocumentoCrearActualizarComponent',
    props: ['loadData'],
    emits: ["updateValues"],
  }
  </script>